import React from "react";
import { compose } from "redux";
import classNames from "classnames";
import { red } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core";

import { CompetencyStatusIcon as CommonCompetencyStatusIcon } from "altus-ui-components";

import { COMPETENCY_STATUS } from "features/planner/planner.constants";

const CompetencyStatusIcon = ({
  status,
  classes,
  noBorder,
  displayTooltipText,
}) => {
  return (
    <CommonCompetencyStatusIcon
      status={status}
      displayTooltipText={displayTooltipText}
      IconProps={{
        fontSize: "small",
        className: classNames(classes.competencyStatusIcon, classes[status], {
          [classes.competencyStatusIconNoBorder]: noBorder,
        }),
      }}
    />
  );
};

const styles = theme => ({
  competencyStatusIcon: {
    borderRadius: "50%",
    border: `2px solid ${theme.palette.common.white}`,
  },
  competencyStatusIconNoBorder: {
    border: 0,
  },
  // The Missing Requirements icon defaults to grey, but in the Personnel Planner it should be red
  [COMPETENCY_STATUS.MISSING_REQUIREMENTS]: {
    "& circle:first-child": {
      fill: red[700],
    },
  },
});

export default compose(withStyles(styles))(CompetencyStatusIcon);
